import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Member/SubscriptionMobilePricing/CancelSubscriptionPromptModal";
import React from "react";
import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

export interface CancelSubscriptionPromptModalProps {
  onClose: () => void;
  onAction: () => void;
  actionLabel: string;
}

export const CancelSubscriptionPromptModal: React.FC<
  CancelSubscriptionPromptModalProps
> = ({ onClose, onAction, actionLabel }) => {
  return (
    <div className="relative flex w-90 max-w-[calc(100vw-72px)] flex-col rounded-2xl bg-background_solid_neutral_secondary px-6 py-6">
      <Icon
        data-openreplay-label="CancelSubscriptionPrompt · close"
        name="close"
        size={20}
        className="button_icon absolute right-3 top-3 z-10 cursor-pointer text-content_primary"
        onClick={onClose}
      />
      <div className="text-center">
        <p className="headline_regular_s text-content_primary">
          {I18n.t("One last step...")}
        </p>
        <p className="mt-2 body_m text-content_secondary">
          {I18n.t("Your Lifetime plan is active! To avoid any future charges,")}
          <span className="body_medium_m text-content_secondary">
            {I18n.t("please manually cancel your old subscription")}
          </span>
          {I18n.t(" in the App Store now.")}
        </p>
      </div>
      <button
        type="button"
        data-openreplay-label="CancelSubscriptionPrompt · manage subscriptions"
        className={cn("button button_m primary_button md_button mt-6 w-full")}
        onClick={onAction}
      >
        {actionLabel}
      </button>
    </div>
  );
};
